import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import {User} from '../model/Entities/User';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {Document} from '../model/Entities/Document';
import {DocumentLiquidation} from '../model/Entities/DocumentLiquidation';

@Injectable()
export class DocumentLiquidationService extends ApiService<DocumentLiquidation> {

    protected apiUrl = 'api/document-liquidation';  // URL to web api

    protected getObjectType(): any {
        return DocumentLiquidation;
    }
}



// WEBPACK FOOTER //
// /app/src/services/documentLiquidation.service.ts